import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import {Box, Button, TextField,Grid, Typography} from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import Divider from '@mui/material/Divider';
import { Link, useNavigate,useParams } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';

const year = new Date().getFullYear();// gets current year
function AddList() {
  const navigate = useNavigate();
  const [monthInput, setMonth] = useState({
    month_name: '',
    year: year,                                   // default field shows current year
    is_closed:0,                                 //default shows open
    error_list:[],
  });
  const handleInput = (e) => {
    e.persist();
    setMonth({...monthInput, [e.target.name]: e.target.value})
    //console.log('Props---',this.props);
  }

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor('#F40B27'),
      apple: createColor('#A38A00'),
      steelBlue: createColor('#5C76B7'),
      violet: createColor('#BC00A3'),
    },
    button: { // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    }, 
  });

  const submitList = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data = {
        month_name: monthInput.month_name,
        year: monthInput.year,
        is_closed:monthInput.is_closed,
        user_id:userId,
    }

    axios.post(`/api/store_listmonth`,data).then(res =>{
      if(res.data.status === 200){
        swal("Success",res.data.message,"success");
        document.getElementById('CATEGORY_FORM').reset();
        navigate('/certificates/show_listmonth');
      }
      else if(res.data.status === 400){
        setMonth({...monthInput,error_list:res.data.errors});
      }
    });
  }


 
     
      return (
   <div>
        <form onSubmit={submitList} id="CATEGORY_FORM">
        <div className="row" style={{ marginTop: 20, width: "97%" }}>
                        // <div className="col-sm-1"></div>
                        <div className="col-sm-12" style={{ marginLeft: 40 }}>
                            <div className="card">
                                <div className="card-header">
                                <div class="d-flex justify-content-between">
                                <h4><b>Add Month</b></h4>
                                <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/show_listmonth" variant='contained' color='apple'>Back</Button>
           </ThemeProvider></div></div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>month_name</label>
                                                <select name="month_name" id="month_name" className="form-control"  onChange={handleInput} value={monthInput.month_name}>
                                                    <option value="">-- month_name --</option>
                                                    <option value="January">January</option>
                                                    <option value="February">February</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                                <span style={{ color: "red" }}>
                                                  {monthInput.error_list.month_name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>year</label>
                                                <input type="text" name="year" id="year" className="form-control" placeholder="Enter year" onChange={handleInput} value={monthInput.year}/>
                                                <span style={{ color: "red" }}>
                                                  {monthInput.error_list.year}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required"  style={{ marginBottom: "7px" }}>is_closed</label>
                                                <select name="is_closed" id="is_closed" className="form-control"  onChange={handleInput} value={monthInput.is_closed} >
                                                    <option value="">--is_closed--</option>
                                                    <option value="0">OPEN</option>
                                                    <option value="1" disabled ={true} >CLOSED</option>
                                                </select>
                                                <span style={{ color: "red" }}>
                                                {monthInput.error_list.is_closed}  
                                                </span>
                                            </div>
                                        </div>
                                       
                                        
                                    </div >

                                    {/* --------------------Item details Add more Display data Start ----------------*/}
                                    
                                    {/* --------------------Item details Add more Display data End ----------------*/}
                                </div>
                                <div className="card-footer text-center"> <button type="submit" id="submit" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Add</button></div>
                            </div>
                            
                        </div>
                        
                    </div>
               </form>
               </div>
               
  );
}



export default AddList